import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const ConceptsTranslations = wrapTranslationsSchema({
	name: 'ConceptsTranslations',
	title: 'Concepts Translations',
	sanityId: 'concepts',
	fields: {
		sourceID: 'Source ID',
		proposedBy: 'Proposed by',
		publishDate: 'Publish Date',
		postedOn: 'Posted on',
		lastVoteDate: 'Last Vote Date',
		levelOfEffort: 'Level of Effort',
		levelOfRisk: 'Level of Risk',
		specifications: 'Specifications',
		sourceDemandProduct: 'Source Demand Product',
		realizedProduct: 'Realized Product',
		conceptValueTitle: 'Concept Value',
		conceptValueTimeEfficiency: 'Time efficiency',
		conceptValueMoneySavings: 'Money savings',
		conceptValueCompliance: 'Compliance',
		conceptValueQuality: 'Quality',
		conceptValueInformationAccess: 'Information access',
		conceptValueWorkforceDevelopment: 'Workforce development',
		conceptValueBlockerRemoval: 'Blocker removal',
		conceptValueGroupMarketValue: 'Market value',
		conceptValueGroupRiskReduction: 'Risk reduction',
		conceptValueGroupCapabilityBuilding: 'Capability building',
		levelVeryLow: 'VeryLow',
		levelLow: 'Low',
		levelMedium: 'Medium',
		levelHigh: 'High',
		levelVeryHigh: 'Very High',
		currencySavingsWeekly: 'Money savings per week',
		currencySavingsMonthly: 'Money savings per month',
		currencySavingsYearly: 'Money savings per year',
		currencySavingsOnce: 'Money savings',
		hoursSavingsWeekly: 'Person-hours per week savings',
		hoursSavingsMonthly: 'Person-hours per month savings',
		hoursSavingsYearly: 'Person-hours per year savings',
		hoursSavingsOnce: 'Person-hours savings',
		statusOpenForVoting: 'Open for Voting',
		statusApproved: 'Approved',
		statusRejected: 'Rejected',
		statusAssignedForImplementation: 'Assigned for Implementation',
		statusCompleted: 'Completed',
		statusHistory: 'Status History',
		statusShowMore: 'Show More',
		statusShowLess: 'Show Less',
		voteButton: 'Vote',
		voteEditButton: 'Edit vote',
		voteCountOne: '{count} vote',
		voteCountOther: '{count} votes',
		voteBusinessCase: 'Business case',
		voteValue: 'Value',
		voteModalTitle: 'Submit your vote',
		voteModalEditTitle: 'Edit your vote',
		voteModalApplicationLabel: 'Please describe your business case.',
		voteModalApplicationDescription: 'How would you utilize this concept if implemented?',
		voteModalValueLabel: 'Please describe provided value.',
		voteModalValueDescription: 'What value will this concept bring to you if implemented?',
		voteModalSubmitButton: 'Submit vote',
		voteModalEditButton: 'Edit vote',
		voteModalDeleteButton: 'Delete',
		voteModalCreateSuccessTitle: 'Your vote has been successfully submitted.',
		voteModalCreateSuccessDescription:
			'Your vote has been submitted and is available in the Votes section. You can edit or delete your vote at any time.',
		voteModalDeleteSuccessTitle: 'Your vote has been deleted.',
		voteModalDeleteSuccessDescription:
			'Your vote has been deleted. You can submit a new vote at any time.',
		voteVotedOn: 'Voted on {date}',
		leaderboardFiltersValueType: 'Value type',
		leaderboardFiltersStatus: 'Status',
		leaderboardFiltersEffort: 'Effort',
		leaderboardFiltersRisk: 'Risk',
		leaderboardFiltersValueInCurrency: 'Value in currency',
		leaderboardFiltersSelected: 'selected',
		leaderboardFiltersClearFilter: 'Clear All',
		leaderboardFiltersShowResults: 'Show results',
		leaderboardFiltersClearAllFilters: 'Clear all filters',
		leaderboardChartLow: 'Low',
		leaderboardChartHigh: 'High',
		leaderboardChartQuickWins: 'Quick wins',
		leaderboardChartFillIns: 'Fill-ins',
		leaderboardChartThanklessTasks: 'Thankless tasks',
		leaderboardChartMajorProjects: 'Major projects',
		leaderboardVotesTotalNumber: 'Total number of votes',
		leaderboardTopValues: 'Top {count} values',
		leaderboardConceptsListTitle: 'Submitted ideas',
	},
});
